/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * UpSmith Dev API
 * OpenAPI spec version: 1.0.0
 */

export type CompetitionLeaderboardView =
  (typeof CompetitionLeaderboardView)[keyof typeof CompetitionLeaderboardView];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CompetitionLeaderboardView = {
  table: "table",
  canvas: "canvas",
} as const;
